interface StageDefinitionLabel {
  stageId: string
  label?: string | null
}

/**
 * The client-facing name for a workflow stage, taken from the Stage Gates
 * definitions. Null when the stage has no definition or its label is blank, so
 * the caller omits the line rather than showing the raw stage id.
 */
export function portalStageLabel(
  stageId: string | null | undefined,
  definitions: readonly StageDefinitionLabel[]
): string | null {
  if (!stageId) return null
  const label = definitions.find((d) => d.stageId === stageId)?.label
  if (typeof label !== 'string') return null
  const trimmed = label.trim()
  return trimmed === '' ? null : trimmed
}
